/**
 * @generated SignedSource<<41490f221b4872fe48a5d7e3dded3f8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Permission = "AccountPermission_System_Root" | "UserInAccountPermission_Brand_CreateBrand" | "UserInAccountPermission_Brand_DeleteBrand" | "UserInAccountPermission_Brand_ReadBrand" | "UserInAccountPermission_Brand_UpdateBrand" | "UserInAccountPermission_Certificates_CreateCertificates" | "UserInAccountPermission_Certificates_DeleteCertificates" | "UserInAccountPermission_Certificates_ReadCertificates" | "UserInAccountPermission_Certificates_UpdateCertificates" | "UserInAccountPermission_Export_CmeExport" | "UserInAccountPermission_Export_ExportNodes" | "UserInAccountPermission_Export_ExportPoints" | "UserInAccountPermission_Export_ExportSafe" | "UserInAccountPermission_Export_ExportUnsafe" | "UserInAccountPermission_Feedbacks_CreateFeedbacks" | "UserInAccountPermission_Feedbacks_DeleteFeedbacks" | "UserInAccountPermission_Feedbacks_ReadFeedbacks" | "UserInAccountPermission_Feedbacks_UpdateFeedbacks" | "UserInAccountPermission_Files_Delete" | "UserInAccountPermission_Import_BasisseminarImport" | "UserInAccountPermission_Import_ImportSafe" | "UserInAccountPermission_Import_ImportUnsafe" | "UserInAccountPermission_Import_InstitutionImport" | "UserInAccountPermission_Import_PACPointsImport" | "UserInAccountPermission_Import_SpecialAccessibleNodeImport" | "UserInAccountPermission_Import_UpdateEmailRequestImport" | "UserInAccountPermission_Instructors_CreateInstructors" | "UserInAccountPermission_Instructors_DeleteInstructors" | "UserInAccountPermission_Instructors_ReadInstructors" | "UserInAccountPermission_Instructors_UpdateInstructors" | "UserInAccountPermission_LandingPages_CreateLandingPages" | "UserInAccountPermission_LandingPages_DeleteLandingPages" | "UserInAccountPermission_LandingPages_ReadLandingPages" | "UserInAccountPermission_LandingPages_UpdateLandingPages" | "UserInAccountPermission_LearnStates_CreateLearnStates" | "UserInAccountPermission_LearnStates_DeleteLearnStates" | "UserInAccountPermission_LearnStates_ReadLearnStates" | "UserInAccountPermission_LearnStates_UpdateLearnStates" | "UserInAccountPermission_Maintenance_UpdateMaintenance" | "UserInAccountPermission_Management_Management" | "UserInAccountPermission_Messaging_CreateMessages" | "UserInAccountPermission_Messaging_DeleteMessages" | "UserInAccountPermission_Messaging_ReadMessages" | "UserInAccountPermission_Messaging_SendMessages" | "UserInAccountPermission_Messaging_UpdateMessages" | "UserInAccountPermission_ModuleRating_Read" | "UserInAccountPermission_NewsLetter_CreateNewsLetter" | "UserInAccountPermission_NewsLetter_DeleteNewsLetter" | "UserInAccountPermission_NewsLetter_ReadNewsLetter" | "UserInAccountPermission_NewsLetter_UpdateNewsLetter" | "UserInAccountPermission_NewsletterSubscription_ReadNewsletterSubscription" | "UserInAccountPermission_NewsletterSubscription_UpdateNewsletterSubscription" | "UserInAccountPermission_Newsticker_CreateMessages" | "UserInAccountPermission_Newsticker_DeleteMessages" | "UserInAccountPermission_Newsticker_ReadMessages" | "UserInAccountPermission_Newsticker_UpdateMessages" | "UserInAccountPermission_Nodes_CreateNodes" | "UserInAccountPermission_Nodes_DeleteNodes" | "UserInAccountPermission_Nodes_PublishNodes" | "UserInAccountPermission_Nodes_ReadNodes" | "UserInAccountPermission_Nodes_UpdateNodes" | "UserInAccountPermission_Points_CreatePoints" | "UserInAccountPermission_Points_DeletePoints" | "UserInAccountPermission_Points_ReadPoints" | "UserInAccountPermission_Points_UpdatePoints" | "UserInAccountPermission_Submissions_ReadSubmissions" | "UserInAccountPermission_System_Owner" | "UserInAccountPermission_Tags_CreateTags" | "UserInAccountPermission_Tags_DeleteTags" | "UserInAccountPermission_Tags_ReadTags" | "UserInAccountPermission_Tags_UpdateTags" | "UserInAccountPermission_Tracking_ReadTracking" | "UserInAccountPermission_TreeStateAdmin_Modify" | "UserInAccountPermission_TreeStateAdmin_Read" | "UserInAccountPermission_TriggerActionAdmin_Modify" | "UserInAccountPermission_TriggerActionAdmin_Read" | "UserInAccountPermission_User_DeleteUser" | "UserInAccountPermission_User_ReadEmailLog" | "UserInAccountPermission_User_ReadUserHistory" | "UserInAccountPermission_User_ReadUsers" | "UserInAccountPermission_User_ResendActivationEmail" | "UserInAccountPermission_User_RestoreUser" | "UserInAccountPermission_User_UpdateUserActivation" | "UserInAccountPermission_User_UpdateUserEmail" | "UserInAccountPermission_User_UpdateUserExtension" | "UserInAccountPermission_User_UpdateUserPassword" | "%future added value";
export type MainNavigation_Query$variables = Record<PropertyKey, never>;
export type MainNavigation_Query$data = {
  readonly Viewer: {
    readonly Auth: {
      readonly currentUser: {
        readonly permissionsInAccount: ReadonlyArray<Permission>;
      } | null | undefined;
    };
  };
};
export type MainNavigation_Query = {
  response: MainNavigation_Query$data;
  variables: MainNavigation_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ViewerQueryType",
    "kind": "LinkedField",
    "name": "Viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthViewerSchema",
        "kind": "LinkedField",
        "name": "Auth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrentUser",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "permissionsInAccount",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MainNavigation_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MainNavigation_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0d00002a582eaa88526f3c201d9ee64d",
    "id": null,
    "metadata": {},
    "name": "MainNavigation_Query",
    "operationKind": "query",
    "text": "query MainNavigation_Query {\n  Viewer {\n    Auth {\n      currentUser {\n        permissionsInAccount\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e1513d2f9f5d12b93e6ea45200f9dce";

export default node;
